<template>
  <div class="w-100">
    <template v-if="manageEventMode">
      <div
        class="alert alert-warning d-flex justify-content-between align-items-center"
      >
        <label class="fs-6">업무가 가능한 시간을 표시하세요</label>
        <button class="btn btn-light" @click="manageEventMode = false">
          완료
        </button>
      </div>
    </template>
    <full-calendar
      :options="{
        ...calendarOptions,
        events,
        dateClick: dateClick,
        eventClick: eventClick,
        customButtons: {
          manageEvent: {
            text: '일정 관리',
            click: manageEventClick,
          },
        },
      }"
    />
    <event-add-modal />
    <event-detail-modal />
    <work-time-add-offcanvas />
  </div>
</template>



<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import timeGridPlugin from "@fullcalendar/timegrid";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import moment from "moment";
import { EventName } from "@/const";

// theme
// https://github.com/fullcalendar/fullcalendar/blob/master/packages/bootstrap5/src/main.ts#L7
bootstrap5Plugin.themeClasses.bootstrap5.prototype.classes.button =
  "btn btn-light";

const sampleEvents = [
  {
    id: Math.random(),
    title: "안고객",
    start: moment().set({ weekday: 1, h: 11, m: 0, second: 0 }).toDate(),
    end: moment().set({ weekday: 1, h: 11, m: 50, second: 0 }).toDate(),
    classNames: ["rose"],
    icon: "camera-video-fill",
  },
  {
    id: Math.random(),
    title: "반고객 / 홍길동",
    start: moment().set({ weekday: 1, h: 16, m: 0, second: 0 }).toDate(),
    end: moment().set({ weekday: 1, h: 16, m: 50, second: 0 }).toDate(),
    classNames: ["green"],
  },
  {
    id: Math.random(),
    title: "삭제고객 / 신사임당 선생님",
    start: moment().set({ weekday: 1, h: 16, m: 0, second: 0 }).toDate(),
    end: moment().set({ weekday: 1, h: 16, m: 50, second: 0 }).toDate(),
    classNames: ["cyan"],
  },
  {
    id: Math.random(),
    title: "삭제고객 / 신사임당 선생님",
    start: moment().set({ weekday: 2, h: 14, m: 0, second: 0 }).toDate(),
    end: moment().set({ weekday: 2, h: 14, m: 50, second: 0 }).toDate(),
    classNames: ["brown"],
    icon: "camera-video-fill",
    resourceId:'미지정'
  },
  {
    id: Math.random(),
    title: "신규 / 첫상담",
    start: moment().set({ weekday: 2, h: 16, m: 30, second: 0 }).toDate(),
    end: moment().set({ weekday: 2, h: 17, m: 20, second: 0 }).toDate(),
    classNames: ["coral"],
    icon: "telephone-fill",
    resourceId:'미지정'
  },
  {
    id: Math.random(),
    title: "신고객",
    start: moment().set({ weekday: 4, h: 12, m: 0, second: 0 }).toDate(),
    end: moment().set({ weekday: 4, h: 12, m: 50, second: 0 }).toDate(),
    classNames: ["red"],
    icon: "camera-video-fill",
    resourceId:'유채바보',
    t_name :'',
  },
  {
    id: Math.random(),
    title: "삭제고객 / 첫상담",
    start: moment().set({ weekday: 4, h: 15, m: 0, second: 0 }).toDate(),
    end: moment().set({ weekday: 4, h: 15, m: 50, second: 0 }).toDate(),
    classNames: ["blue"],
    resourceId:'유채바보'
  },
  {
    id: Math.random(),
    title: "집단상담",
    start: moment().set({ weekday: 5, h: 11, m: 0, second: 0 }).toDate(),
    end: moment().set({ weekday: 5, h: 12, m: 40, second: 0 }).toDate(),
    classNames: ["yellow"],
    icon: "telephone-fill",
    resourceId:'유채바보'
  },
  {
    id: Math.random(),
    title: "삭제고객 / ㅇㅇㅇ",
    start: moment().set({ weekday: 6, h: 16, m: 0, second: 0 }).toDate(),
    end: moment().set({ weekday: 6, h: 17, m: 0, second: 0 }).toDate(),
    classNames: ["violet"],
    icon: "telephone-fill",
    resourceId:'유채바보'
  },
];

export default {
  name: "EpiCalendar",
  components: {
    FullCalendar,
  },
  data() {
    return {
      calendarOptions: {
        plugins: [
          interactionPlugin,
          dayGridPlugin,
          listPlugin,
          timeGridPlugin,
          bootstrap5Plugin,
          resourceTimeGridPlugin
        ],
        
        resources: [
          { id: '유채바보', title: '이쁜이' },
          { id: '미지정', title: '미지정' }
        ],
        locale: "ko",
        themeSystem: "bootstrap5",
        initialView: "timeGridWeek",
        schedulerLicenseKey :'0811561655-fcs-1661586148',
        // toolbar
        scrollTime : '08:00:00',
        headerToolbar: {
          start: "prev,next today",
          center: "title",
          end: "manageEvent dayGridMonth,timeGridWeek,resourceTimeGridDay,listMonth",
        },
        nowIndicator: true,
        allDayDefault:false,
        allDaySlot : false,
        navLinks : true,
        buttonText:{
					today:    '오늘',
				},
        // view format
        views: {
          dayGridMonth: { buttonText: '월' },
          timeGridWeek: { buttonText: '주' },
          resourceTimeGridDay: { buttonText: '일' },
          listMonth: { buttonText: '목록' },
          // dayGridMonth: {
          //   eventTimeFormat: {
          //     hour: "numeric",
          //     minute: "numeric",
          //     omitZeroMinute: true,
          //     meridiem: "long",
          //   },
          // },
          // timeGridWeek: {
          //   title: "short",
          // },
        },
        editable: true,
        height: "100vh",
        expandRows: true,
        eventDidMount(e) {
          try {
            const icon = e.event._def.extendedProps.icon;

            const i = document.createElement("i");
            i.classList.add("bi");
            i.classList.add("bi-" + (icon ? icon : ""));
            i.classList.add("me-2");
            i.classList.add("pointer");
            i.classList.add("text-black-50");
            i.style.fontSize = "0.7rem";

            const a = document.createElement("a");
            a.append(i);

            a.onclick = (clickEvent) => {
              clickEvent.stopPropagation();

              const event = e.event._def;
              // console.log(event);
              // icon click event handler...
              alert(event.title);
            };

            const elTitle = e.el.querySelector(".fc-event-time");
            elTitle.append(a);
            elTitle.classList.add("d-flex");
            elTitle.classList.add("justify-content-between");
            elTitle.classList.add("align-items-center");
          } catch {
            // ignored
          }
        },
      },
      events: [],
      manageEventMode: false,
      s_date : ''
    };
  },
  methods: {
    GetData(info){
      this.s_date = moment(info.start).format('YYYY-MM-DD');
      this.e_date = moment(info.end).format('YYYY-MM-DD');
      
    },
    dateClick() {
      if (this.manageEventMode) {
        this.$root.$emit(EventName.WorkTimeAddOffcanvasOpening);
      } else {
        this.$root.$emit(EventName.EventAddModalOpening);
      }
    },
    eventClick() {
      // https://fullcalendar.io/docs/eventClick
      this.$root.$emit(EventName.EventDetailModalOpening);
    },
    manageEventClick() {
      this.manageEventMode = true;
      this.events = [];
    },
  },
  mounted() {
    this.events.push(...sampleEvents);
  },
};
</script>

<style lang="stylus">
.fc
  color black
  font-weight normal
  // noto sans font makes calendar super slow scrolling in mobile
  font-family 'Arial', sans-serif

  .btn-light
    --bs-btn-padding-x 0.75rem

.fc-view
  background-color white

// fullcalendar bootstrap5 theme overrides
// https://github.com/fullcalendar/fullcalendar/blob/master/packages/bootstrap5/src/main.css
.fc-theme-bootstrap5
  & td, th
    border 1px solid rgba(200 200 200 0.25)

.fc-header-toolbar
  flex-wrap wrap
  gap 0.3rem

.fc-event
  padding-left 5px
  border 0
  cursor pointer

  .fc-daygrid-event-dot, .fc-list-event-dot
    display none

  &.green
    border-left 3px solid var(--epi-cal-border-green)
    background-color var(--epi-cal-bg-green)

  &.cyan
    border-left 3px solid var(--epi-cal-border-cyan)
    background-color var(--epi-cal-bg-cyan)

  &.brown
    border-left 3px solid var(--epi-cal-border-brown)
    background-color var(--epi-cal-bg-brown)

  &.blue
    border-left 3px solid var(--epi-cal-border-blue)
    background-color var(--epi-cal-bg-blue)

  &.red
    border-left 3px solid var(--epi-cal-border-red)
    background-color var(--epi-cal-bg-red)

  &.rose
    border-left 3px solid var(--epi-cal-border-rose)
    background-color var(--epi-cal-bg-rose)

  &.coral
    border-left 3px solid var(--epi-cal-border-coral)
    background-color var(--epi-cal-bg-coral)

  &.yellow
    border-left 3px solid var(--epi-cal-border-yellow)
    background-color var(--epi-cal-bg-yellow)

  &.violet
    border-left 3px solid var(--epi-cal-border-violet)
    background-color var(--epi-cal-bg-violet)

// hide icons in daygrid view
.fc-daygrid-day-events i
  display none
</style>

<style scoped>
.fc-timegrid-slot {
    height: 100em;
    border-bottom: 0 !important;
}
</style>